import { useToast } from '@chakra-ui/react';
import { AxiosError, AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useRouter } from 'next/router';
import { useState } from 'react';
import * as Yup from 'yup';

import { ISingleBaseResponse } from '@interfaces/IBaseResponse';
import { actionPostRegister } from '@libraries/api/register/register.function';
import { IParamRegister, IResponseRegister } from '@libraries/api/register/register.types';
import { showToast } from '@utils/constant';

export const useAction = () => {
  const router = useRouter();
  const toast = useToast();

  const initialValues: IParamRegister = {
    company_name: '',
    email: '',
    password: '',
  };

  const [isShowPassword, setIsShowPassword] = useState<boolean>(false);

  const onShowPassword = () => setIsShowPassword(!isShowPassword);

  const { isLoading, mutate } = actionPostRegister();

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      company_name: Yup.string().required('Nama perusahaan harus diisi!'),
      email: Yup.string()
        .email('Email tidak valid!')
        .required('Email harus diisi!'),
      password: Yup.string()
        .min(6, 'Password minimal 6 karakter!')
        .required('Password harus diisi!'),
    }),
    onSubmit: (values: IParamRegister) => {
      mutate(values, {
        onSuccess: ({
          data,
        }: AxiosResponse<ISingleBaseResponse<IResponseRegister>>) => {
          showToast({
            toast,
            title: 'Berhasil!',
            description: 'Registrasi berhasil. Silakan login.',
            status: 'success',
          });
          router.push('/login');
        },
        onError: (err: AxiosError<ISingleBaseResponse<null>>) => {
          const msg = err.response?.data?.msg?.id || 'Registrasi gagal';
          showToast({
            toast,
            title: 'Oops!',
            description: msg,
            status: 'error',
          });
        },
      });
    },
  });

  return {
    formik,
    isShowPassword,
    onShowPassword,
    isLoading,
  };
};